package com.milta.feature.subscription.domain.usecase

import com.milta.feature.subscription.domain.entity.SubscriptionPlanInfo
import com.milta.feature.subscription.domain.repository.SubscriptionRepository

class GetSubscriptionPlansUseCase(private val repository: SubscriptionRepository) {
    suspend operator fun invoke(): Result<List<SubscriptionPlanInfo>> = repository.getPlans()
}
